import { Row, Col } from "antd";
import TitleComponent from "./Title";
import Can from "../../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
import CatalogueCard from "./CatalogueCard";
import ProductCard from "./ProductCard";
import HistoryCard from "./HistoryCard";

export default function Dashboard() {
  return (
    <div style={{ marginTop: "4rem" }}>
      <TitleComponent />

      <Row style={{ marginTop: "3.5rem" }}>
        <Col
          xs={24}
          sm={24}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          {/* casl starts here */}
          <Can
            I={PERMISSIONS.view_products.slug}
            a={PERMISSIONS.view_products.permissionType}
            passThrough
          >
            {(allowed) => <ProductCard allowed={allowed} />}
          </Can>
          {/* casl ends here */}
        </Col>

        <Col
          xs={24}
          sm={24}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          {/* casl starts here */}
          <Can
            I={PERMISSIONS.create_catalogues.slug}
            a={PERMISSIONS.create_catalogues.permissionType}
            passThrough
          >
            {(allowed) => <CatalogueCard allowed={allowed} />}
          </Can>
          {/* casl ends here */}
        </Col>

        <Col
          xs={24}
          sm={24}
          md={{ span: 24 }}
          lg={{ span: 8 }}
          xl={{ span: 8 }}
        >
          {/* casl starts here */}
          <Can
            I={PERMISSIONS.view_catalogues.slug}
            a={PERMISSIONS.view_catalogues.permissionType}
            passThrough
          >
            {(allowed) => <HistoryCard allowed={allowed} />}
          </Can>
          {/* casl ends here */}
        </Col>
      </Row>
    </div>
  );
}